import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { arrayOf, bool, number, oneOf, shape, string } from 'prop-types';

import { formatMoney } from '../../../../util/currency';
import { propTypes } from '../../../../util/types';
import { intlShape } from '../../../../util/reactIntl';

import css from '../../OrderItemInfo.css';

const LongTermDiscount = ({ discount, intl }) => {
  if (!discount || !discount.lineTotal.amount) return null;
  const { lineTotal, code } = discount;

  return (
    <p className={classNames(css.text, css.priceContainer)} key={code}>
        <span className={css.productName}>
          <FormattedMessage id="OrderInfo.discountText" />
        </span>
      <span className={css.text}>{formatMoney(intl, lineTotal)}</span>
    </p>
  );
}

LongTermDiscount.propTypes = {
  intl: intlShape.isRequired,
  discount: shape({
      code: propTypes.value('long-term-discount').isRequired,
      includeFor: arrayOf(oneOf(['customer', 'provider'])).isRequired,
      quantity: number,
      unitPrice: shape({
        amount: number,
        currency: string,
      }),
      lineTotal: shape({
        amount: number,
        currency: string,
      }),
      reversal: bool,
      seats: number,
  })
}

export default LongTermDiscount;
